// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper___b1id","background_feather":"Modal_background_feather__2FCc4","seperator":"Modal_seperator__thn2m","modalBox":"Modal_modalBox__2-Y8b"};